import Emitter from "es6-event-emitter";
import pdfDownload from "./../templates/pdfDownload.dust";

import language from "./../dictionary";

export default class pdfDownloadComponent extends Emitter {
  appState;
  options;
  DOMContainer;

  constructor(appState, DOMContainer, options = {}) {
    super();
    this.appState = appState;
    this.options = options;
    this.DOMContainer = DOMContainer;
    this.render();
  }

  render() {
    if (this.DOMContainer) {
      const context = {};
      context.fullPdf = language.fullPdfDownload;
      context.singlePage = language.pagePdfDownload;
      context.leftPage = language.LeftPage;
      context.rightPage = language.RightPage;
      context.isSingle = this.isSinglePage();
      context.allowFullPdfDownload = this.options.allowFullPdfDownload;
      Dust.render(pdfDownload, context, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.attatchClickHandlers();
      });
    }
  }

  attatchClickHandlers() {
    const downloadItems = this.DOMContainer.querySelectorAll(".download-item");
    downloadItems.forEach((item) => {
      const download = item.getAttribute("data-download");
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        switch (download) {
          case "fullPdf":
            this.trigger("pdfDownloadComponent:downloadFullPdf");
            break;
          case "singlePage":
            this.trigger("pdfDownloadComponent:downloadSinglePagePdf");
            break;
          case "leftPage":
            this.trigger("pdfDownloadComponent:downloadLeftPagePdf");
            break;
          case "rightPage":
            this.trigger("pdfDownloadComponent:downloadRightPagePdf");
            break;
          default:
        }
      });
    });
  }

  toggleVisibility() {
    this.render(); // The dropdown download menu needs to be re-rendered in order to start/stop displaying certain buttons
    this.DOMContainer.classList.toggle("hidden");
  }

  close() {
    if (!this.DOMContainer.classList.contains("hidden")) {
      this.DOMContainer.classList.add("hidden");
    }
  }

  isSinglePage() {
    const activePages = this.appState.activePages;

    if (activePages.length == 1) {
      return true;
    } else {
      return activePages[0] == null || activePages[1] == null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/pdfDownloadComponent.js